import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { bundledProductGroupDetails } from 'constants/purchaseFlowRevamp/productGroupDetails'
import type { ProductGroupDetails } from 'models/purchaseFlowRevamp'

/**
 * Detail content for a product group, in the active locale.
 *
 * THE SEAM. Content is bundled today, scraped from bkbn.com's portfolio pages,
 * and is expected to move to the backend. Everything that renders it reads it
 * through here, so that move is a change of source in this file: swap the
 * lookup for a query, keep returning `ProductGroupDetails`. Consumers already
 * treat `undefined` as "no detail for this group", which is also what a request
 * that has not resolved yet looks like.
 */
/**
 * Whether there is anything to show. Shared so the card and the panel cannot
 * disagree — a card offering information that opens onto an empty panel is
 * worse than no card action at all.
 */
export const hasProductGroupDetails = (details?: ProductGroupDetails): boolean =>
  Boolean(details?.gallery.length || details?.terms.length || details?.deliverables.length)

export function useProductGroupDetails(productGroupCode?: string): ProductGroupDetails | undefined {
  const { t, i18n } = useTranslation(['purchase_flow_revamp'])

  return useMemo(
    () => bundledProductGroupDetails(t, productGroupCode, i18n.language),
    [t, productGroupCode, i18n.language]
  )
}
